import type React from 'react';
import { type ChangeEvent, useCallback, useState } from 'react';
import QuickReplyList from '../../containers/QuickReplyList';
import type { Button, TDropdownPayload } from '../../types/ChatWindow';
import type { MessageScheme } from '../../types/configs';

interface Props {
  scheme: MessageScheme;
  submitHandler: (...args: any[]) => void;
  data: TDropdownPayload['data'];
  isLastMessage: boolean;
}

const DropdownIconPlaceholder = () => {
  return (
    <svg aria-hidden='true' fill='#00000080' viewBox='0 0 24 24' width='24'>
      <path d='M7 10l5 5 5-5z' />
    </svg>
  );
};

export const DropdownMessage: React.FC<Props> = ({
  submitHandler,
  data,
  scheme,
  isLastMessage,
}) => {
  const { content, description, submitButtonText } = data;
  const [contentValue, setContentValue] = useState(content[0]);
  const [clicked, setClicked] = useState(false);

  const handleSelectChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      const { value } = event.target;

      const foundContent = content.find((con) => con.value === value);

      if (!foundContent) {
        return;
      }

      setContentValue(foundContent);
    },
    [content],
  );

  const buttons: Button[] = [
    {
      title: submitButtonText ?? 'Submit',
      type: 'payload',
      payload: contentValue.value,
    },
  ];

  const handleClick = useCallback(
    (button: Button) => {
      submitHandler({ value: button });
      setClicked(true);
    },
    [submitHandler],
  );

  return (
    <>
      <div className='dropdown-message-container word-break-style'>
        <div className='dropdown-message-description'>{description}</div>

        <div className='dropdown-row'>
          <select
            value={contentValue.value}
            onChange={handleSelectChange}
            className='dropdown-content'>
            {content.map((contentEntry) => {
              return (
                <option key={contentEntry.id} value={contentEntry.value}>
                  {contentEntry.name}
                </option>
              );
            })}
          </select>
          <div className='dropdown-icon'>
            <DropdownIconPlaceholder />
          </div>
        </div>

        {clicked || !isLastMessage ? null : (
          <QuickReplyList
            buttons={buttons}
            onClick={handleClick}
            scheme={scheme}
          />
        )}
      </div>
    </>
  );
};
